/**
 * How many photos the strip shows at most. A rendering cap, not a page size: the strip
 * reads the photo-only reviews page from the store (fetched separately) and shows at most
 * this many tiles.
 */
export const CUSTOMERS_PHOTOS_COUNT = 10;
